import React from "react";
import ReactDOM from "react-dom";
import "./amplifyClient";
import App from "./containers/App";
import "./index.css";

ReactDOM.render(
  <App />,
  document.getElementById("root")
);
